import { FC } from "react";
import styled from "styled-components";

import { PanelTop } from "@ryde/layout";
import { IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

import { ViewSwitchCourses } from "../panels/panel-top/view-switch.courses";

const CoursesGridViewSwitchBarStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "courses-grid-view-switch-bar",
})`
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
  padding-inline: 26px 15px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

/** Toolbar under the header on courses grid: view switch + stats panel. */
export const CoursesGridBottomWidget: FC = () => (
  <>
    <CoursesGridViewSwitchBarStyled>
      <ViewSwitchCourses />
    </CoursesGridViewSwitchBarStyled>
    <PanelTop />
  </>
);
